"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["title"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.klass),
        title: _ctx.$t(_ctx.description),
        "data-test": "tile"
    }, null, 10, _hoisted_1));
}
